import { styled } from '@mui/material/styles';
import { Dialog, TableCell, TableRow } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '80%',
    height: '70%',
    maxWidth: 'none',
    overflowY: 'auto'
  }
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.header': {
    color: theme.palette.common.white,
    fontWeight: 'bold',
    backgroundColor: theme.palette.primary.main
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&.dictionary-row': {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '& .label-cell': {
      fontWeight: 'bold'
    }
  }
})); 